"use client";

import { useEffect } from "react";
import Link from "next/link";

import { Button } from "@/components/ui/button";

type ErrorProps = {
	error: Error & { digest?: string };
	reset?: () => void;
};

export default function Error({ error, reset }: ErrorProps) {
	useEffect(() => {
		// Log the error to an error reporting service
		console.error("Application error:", error);
	}, [error]);

	const handleReset = () => {
		if (reset && typeof reset === "function") {
			reset();
		} else {
			// Fallback: reload the page if reset is not available
			window.location.reload();
		}
	};

	return (
		<div className="container flex min-h-[calc(100lvh-90px)] flex-col items-center justify-center p-8">
			<div className="w-full max-w-md space-y-4 text-center">
				<h1 className="text-3xl font-semibold text-tertiary">Something went wrong!</h1>
				<p className="text-muted-foreground">
					An unexpected error occurred. Please try again.
				</p>
				{error?.digest && (
					<p className="text-xs text-muted-foreground">Error ID: {error.digest}</p>
				)}
				<div className="flex justify-center gap-4">
					<Button onClick={handleReset} size="lg">
						Try again
					</Button>
					<Button asChild variant="outline" size="lg">
						<Link href="/">Go home</Link>
					</Button>
				</div>
			</div>
		</div>
	);
}

